(ns serv-ui.push
  "Notifications for the operator prompts window: its worker
  (/sw.js on ops) subscribed to Web Push, the subscription handed
  to the server (`serv.push`), which then pushes every new prompt to this
  browser. Asked for right after sign-in; a browser that would not ask then
  (no user gesture left) gets a button."
  (:require [serv-ui.api :as api]))

(defonce !permission (atom nil))

(defn supported? []
  (and (exists? js/navigator.serviceWorker) (exists? js/PushManager) (exists? js/Notification)))

(defn- refresh! []
  (reset! !permission (when (supported?) (.-permission js/Notification))))

(defn- key-bytes
  "The server's VAPID key, base64url, as the bytes `subscribe` wants."
  [s]
  (let [b64 (-> s (.replace (js/RegExp. "-" "g") "+") (.replace (js/RegExp. "_" "g") "/"))
        b64 (str b64 (subs "===" 0 (mod (- 4 (mod (count b64) 4)) 4)))
        raw (js/atob b64)]
    (js/Uint8Array.from raw #(.charCodeAt % 0))))

(defn- registration> []
  (.register js/navigator.serviceWorker "/sw.js" #js {:scope "/"}))

(defn- subscribe>
  "Subscribe this browser, or take its subscription, and tell the server."
  []
  (-> (registration>)
      (.then (fn [_] (.-ready js/navigator.serviceWorker)))
      (.then (fn [^js reg]
               (-> (.getSubscription (.-pushManager reg))
                   (.then (fn [sub]
                            (or sub
                                (-> (api/get> "/api/push/key")
                                    (.then (fn [{k :key}]
                                             (.subscribe (.-pushManager reg)
                                                         #js {:userVisibleOnly true
                                                              :applicationServerKey (key-bytes k)}))))))))))
      (.then (fn [^js sub]
               (api/request> :put "/api/push/subscription"
                             (js->clj (.toJSON sub) :keywordize-keys true))))))

(defn sync!
  "Signed in: keep the server's copy of a granted subscription current."
  []
  (refresh!)
  (when (= "granted" @!permission)
    (-> (subscribe>) (.catch #(js/console.warn "push:" (ex-message %))))))

(defn ask!
  "Ask for the permission, and subscribe if it is given."
  []
  (when (supported?)
    (-> (.requestPermission js/Notification)
        (.then (fn [_] (sync!)))
        (.catch (fn [e] (refresh!) (js/console.warn "push:" (ex-message e)))))))
